__turbopack_context__.v({
  "className": "jetbrains_mono_51ce2bab-module__tcWUKq__className",
});
